import React, { createContext, useContext, useState } from 'react';

const ContrailContext = createContext();

export const ContrailProvider = ({ children }) => {
    const [intersectingPolygons, setIntersectingPolygons] = useState([]);
    const [filteredContrails, setFilteredContrails] = useState([]);
    const [geoJsonFeatures, setGeoJsonFeatures] = useState([]); // Add FOV polygons state

    return (
        <ContrailContext.Provider value={{ intersectingPolygons, setIntersectingPolygons, filteredContrails, setFilteredContrails, geoJsonFeatures, setGeoJsonFeatures }}>
            {children}
        </ContrailContext.Provider>
    );
};

export const useContrailContext = () => useContext(ContrailContext);
